var React = require('react');

function IconInfo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0ZM11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2ZM11 9C11.5523 9 12 9.44772 12 10V16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16V10C10 9.44772 10.4477 9 11 9ZM11 5C11.552 5 12 5.448 12 6C12 6.552 11.552 7 11 7C10.448 7 10 6.552 10 6C10 5.448 10.448 5 11 5Z"}));
}

IconInfo.defaultProps = {"viewBox":"0 0 22 22","fill":"none"};

module.exports = IconInfo;

IconInfo.default = IconInfo;
